import { Route, NavLink, HashRouter } from "react-router-dom";
import SessionRouter from "./session/SessionRouter";
import CreateGame from "./game/create/CreateGame";
import SearchGame from "./game/search/SearchGame";
import PlayingGame from "./game/play/PlayingGame";
import React, { FunctionComponent, useState, useEffect, Dispatch } from "react";
import Friends from "./friends/Friends";
import Profile from "./profile/Profile";
import { connect, ConnectedProps } from "react-redux";
import Bar from "./common/Bar/Bar";
import Shop from "./shopping/Shop";
import { fetchProfileInfo } from "../redux/actions/ProfileActions";
import { fetchFriendsInfo } from "../redux/actions/FriendsActions";
import { setUser } from "../redux/actions/AuthActions";
import { FREE_EXPANSION } from "../constants/expansions";
import {
  fetchExpansionsInfo,
  fetchExpansionsImages
} from "../redux/actions/ExpansionsActions";
import CenteredLoader from "./common/CenteredLoader";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SearchingGame from "./game/SearchingGame";
import AddBoxTwoToneIcon from "@material-ui/icons/AddBoxTwoTone";
import PlayArrowTwoToneIcon from "@material-ui/icons/PlayArrowTwoTone";
import GroupAddTwoToneIcon from "@material-ui/icons/GroupAddTwoTone";
import SettingsTwoToneIcon from "@material-ui/icons/SettingsTwoTone";
import SearchTwoToneIcon from "@material-ui/icons/SearchTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import {
  AuthInterface,
  authActionInterface
} from "../redux/reducers/AuthReducers";
import {
  ExpansionInterface,
  ExpansionsActionInterface
} from "../redux/reducers/ExpansionsReducers";
import {
  ProfileInterface,
  profileActionInterface
} from "../redux/reducers/ProfileReducers";
import {
  GameInterface,
  gameActionInterface
} from "../redux/reducers/GameReducers";
import {
  FriendsInterface,
  friendActionInterface
} from "../redux/reducers/FriendsReducers";

interface actionsType {
  setUser: () => (dispatch: Dispatch<authActionInterface>) => void;
  fetchProfileInfo: () => (
    dispatch: Dispatch<gameActionInterface | profileActionInterface>
  ) => void;
  fetchFriendsInfo: () => (dispatch: Dispatch<friendActionInterface>) => void;
  fetchExpansionsInfo: () => (
    dispatch: Dispatch<ExpansionsActionInterface>
  ) => void;
  fetchExpansionsImages: () => (
    dispatch: Dispatch<ExpansionsActionInterface>
  ) => void;
}
interface RootState {
  profile: ProfileInterface;
  game: GameInterface;
  friends: FriendsInterface;
  expansion: ExpansionInterface;
  auth: AuthInterface;
}

const actionsReducers: actionsType = {
  setUser,
  fetchProfileInfo,
  fetchFriendsInfo,
  fetchExpansionsInfo,
  fetchExpansionsImages
};

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
  profile: state.profile,
  friends: state.friends,
  expansion: state.expansion,
  game: state.game
});

const connector = connect(mapStateToProps, actionsReducers);

type PropsFromRedux = ConnectedProps<typeof connector>;
interface MainProps {}

const Main: FunctionComponent<MainProps & PropsFromRedux> = props => {
  const [itemList, setItemList] = useState([] as JSX.Element[]);

  useEffect(() => {
    window.addEventListener("online", handleConnectionChange);
    window.addEventListener("offline", handleConnectionChange);
    function handleConnectionChange() {
      const condition = navigator.onLine ? "online" : "offline";
      if (condition === "online") {
        const webPing = setInterval(() => {
          props.setUser();
          fetch("//google.com", {
            mode: "no-cors"
          })
            .then(() => {
              toastSuccess("Reconnected");
              return clearInterval(webPing);
            })
            .catch(() => {
              toast.error("Connection lost", {
                autoClose: 1000
              });
            });
        }, 1000);
        return;
      } else {
        toast.error("Connection lost", {
          autoClose: 1000
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    return setItemList(getItemList(props.game.playing));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.game.playing]);

  useEffect(() => {
    if (!props.auth.user?.uid) {
      toastSuccess("Connected");
      props.setUser();
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function fetchInfo() {
    props.fetchProfileInfo();
    props.fetchFriendsInfo();
    props.fetchExpansionsInfo();
    props.fetchExpansionsImages();
  }
  function renderContent() {
    if (props.auth.loading) {
      return <CenteredLoader />;
    }
    if (props.auth?.user?.uid) {
      if (
        !props.profile.info &&
        !props.profile.loading &&
        !props.friends.loading &&
        !props.friends.info &&
        props.expansion.expansions &&
        props.expansion.expansions[FREE_EXPANSION].count === 0
      ) {
        fetchInfo();
      }
      return (
        <HashRouter>
          <div>
            <div style={{ marginBottom: 100 }} className="content">
              <Route exact path="/" component={Profile} />
              <Route path="/friends" component={Friends} />

              <Route
                path="/game"
                component={
                  props.profile?.info
                    ? props.game.playing
                      ? PlayingGame
                      : CreateGame
                    : SearchingGame
                }
              />

              <Route path="/search-game" component={SearchGame} />
              <Route path="/shop" component={Shop} />
            </div>
            <Bar itemList={itemList} lengthList={itemList.length} />
          </div>
          <ToastContainer />
        </HashRouter>
      );
    }

    return <SessionRouter />;
  }
  return (
    <div style={{ margin: 30 }}>
      <h1>Tixid</h1>
      {renderContent()}
    </div>
  );
};

export default connector(Main);

const getItemList = (playing: boolean) => {
  return [
    <NavLink to="/shop">
      {/* Shopping */}
      <ShoppingCartTwoToneIcon style={{ width: "100%" }} className="icon" />
    </NavLink>,
    <NavLink to="/search-game">
      {/* Search */}
      <SearchTwoToneIcon className="icon" style={{ width: "100%" }} />
    </NavLink>,
    <NavLink to="/game">
      {/* CreateGame */}
      {playing ? (
        <PlayArrowTwoToneIcon
          color="secondary"
          style={{ width: "100%" }}
          className="icon"
        />
      ) : (
        <AddBoxTwoToneIcon
          color="primary"
          style={{ width: "100%" }}
          className="icon"
        />
      )}
    </NavLink>,
    <NavLink to="/friends">
      {/* Friends */}
      <GroupAddTwoToneIcon style={{ width: "100%" }} className="icon" />
    </NavLink>,
    <NavLink to="/">
      {/* Profile */}
      <SettingsTwoToneIcon style={{ width: "100%" }} className="icon" />
    </NavLink>
  ];
};

function toastSuccess(message: string) {
  toast(message, {
    autoClose: 1000,
    toastId: 1
  });
}
